"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  padding-left: 8px;\n  padding-right: 8px;\n  flex: 1 0 100%;\n\n  // xs\n  @media print, screen and (max-width: ", "px) {\n    ", "\n    ", "\n  }\n\n  // sm\n  @media print, screen and (min-width: ", "px) {\n    ", "\n    ", "\n  }\n\n  // md\n  @media print, screen and (min-width: ", "px) {\n    ", "\n    ", "\n  }\n\n  // lg\n  @media print, screen and (min-width: ", "px) {\n    ", "\n    ", "\n  }\n\n  // xl\n  @media print, screen and (min-width: ", "px) {\n    ", "\n    ", "\n  }\n\n  // xs\n  @media print, screen and (max-width: ", "px) {\n    display: ", ";\n  }\n\n  // sm\n  @media print, screen and (min-width: ", "px) and (max-width: ", "px) {\n    display: ", ";\n  }\n\n  // md\n  @media print, screen and (min-width: ", "px) and (max-width: ", "px) {\n    display: ", ";\n  }\n\n  // lg\n  @media print, screen and (min-width: ", "px) and (max-width: ", "px) {\n    display: ", ";\n  }\n\n  // xl\n  @media print, screen and (min-width: ", "px) {\n    display: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var COLUMNS = 12;

var colWidth = function colWidth(key) {
  return function (props) {
    return props[key] && "flex-basis: ".concat(props[key] / COLUMNS * 100, "%;");
  };
}; // hacky IE11 fix for padding exceeding width of flex-basis


var maxWidth = function maxWidth(key) {
  return function (props) {
    return props[key] && "max-width: ".concat(props[key] / COLUMNS * 100, "%;");
  };
};

var Element = _styledComponents.default.div.attrs(function (_ref) {
  var className = _ref.className;
  return {
    className: className || 'col'
  };
})(_templateObject(), _Constant.Width.XS, colWidth('xs'), maxWidth('xs'), _Constant.Width.SM, colWidth('sm'), maxWidth('sm'), _Constant.Width.MD, colWidth('md'), maxWidth('md'), _Constant.Width.LG, colWidth('lg'), maxWidth('lg'), _Constant.Width.XL, colWidth('xl'), maxWidth('xl'), _Constant.Width.XS, function (props) {
  return props.xsNone ? 'none' : null;
}, _Constant.Width.SM, _Constant.Width.MD - 1, function (props) {
  return props.smNone ? 'none' : null;
}, _Constant.Width.MD, _Constant.Width.LG - 1, function (props) {
  return props.mdNone ? 'none' : null;
}, _Constant.Width.LG, _Constant.Width.XL - 1, function (props) {
  return props.lgNone ? 'none' : null;
}, _Constant.Width.XL, function (props) {
  return props.xlNone ? 'none' : null;
});

var Col = function Col(props) {
  return /*#__PURE__*/_react.default.createElement(Element, props);
};

Col.propTypes = {
  /** number of columns to span when screen is xs  */
  xs: _propTypes.default.number,

  /** number of columns to span when screen is sm  */
  sm: _propTypes.default.number,

  /** number of columns to span when screen is md  */
  md: _propTypes.default.number,

  /** number of columns to span when screen is lg  */
  lg: _propTypes.default.number,

  /** number of columns to span when screen is xl  */
  xl: _propTypes.default.number,

  /** do not show when screen is xs */
  xsNone: _propTypes.default.bool,

  /** do not show when screen is sm */
  smNone: _propTypes.default.bool,

  /** do not show when screen is md */
  mdNone: _propTypes.default.bool,

  /** do not show when screen is lg */
  lgNone: _propTypes.default.bool,

  /** do not show when screen is xl */
  xlNone: _propTypes.default.bool
};
Col.defaultProps = {
  xs: undefined,
  sm: undefined,
  md: undefined,
  lg: undefined,
  xl: undefined,
  xsNone: false,
  smNone: false,
  mdNone: false,
  lgNone: false,
  xlNone: false
};
var _default = Col;
exports.default = _default;